import pmtService from '@/services/pmtService';

export default {
  namespaced: true,
  state: {
    coupon: {},
    customizeCouponActivity: {},
  },
  mutations: {
    set(state, { name, value }) {
      state[name] = value;
    },
    push(state, { name, value }) {
      state[name].push(value);
    },
    delete(state, { name }) {
      state[name] = null;
    },
  },
  actions: {
    // 取得會籍資料
    getPrizeCustomizeCoupon({ rootState }, payload) {
      const params = {
        companyID: rootState.companyId,
        couponNo: payload.couponNo,
      };
      return pmtService.getPrizeCustomizeCoupon(params).toPromise();
    },
    getCoupon: ({ commit, rootState }, couponNo) => {
      const params = {
        couponNo,
        companyId: rootState.companyId,
      };
      return pmtService.getCoupon(params).then((res) => {
        if (res && res.response.success) {
          commit('set', { name: 'coupon', value: res.response.data[0] });
          commit('set', { name: 'couponNo', value: couponNo });
        }
      });
    },
    postCustomizeCouponActivity({ rootState }, payload) {
      const body = {
        companyID: rootState.companyId,
        sourceType: payload.sourceType,
        source: payload.source,
        loginType: payload.loginType,
        customerId: payload.customerId,
        couponNo: payload.couponNo,
        couponLimitCnt: payload.couponLimitCnt,
        detailId: payload.unionId,
      };
      return pmtService.postCustomizeCouponActivity(body);
    },
  },
};
